import React, { Component } from 'react'
import axios from 'axios'
import SmoothScroll from 'smooth-scroll'
import classnames from 'classnames'
import Favicon from 'react-favicon'
import Loader from 'components/Loader'
import Meta from 'components/MetaHandler'
import Errors from 'components/Errors'

import Header from 'components/Header'
import Footer from 'components/Footer'

import { parseApiData, getApiEndpoint } from 'utils'

import './page.css'

import PageHeader from './Header'
import Grid from 'components/Grid'
import Slider from 'components/Slider'
import Content from './Content'

class Page extends Component {
  /**
   *
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      slug: this.props.location.match.url === '/' ? 'insights-lead-design-for-brands-of-the-future' : this.props.location.match.url.substr(1),
      parsedData: false
    }

    this.init = this.init.bind(this)
    this.fetchEndpoint = this.fetchEndpoint.bind(this)
  }

  /**
   *
   */
  componentDidMount () {
    this.fetchEndpoint(getApiEndpoint(this.state.slug), this.init)
  }

  /**
   *
   * @param prevProps
   * @param prevState
   * @param snapshot
   */
  componentDidUpdate (prevProps, prevState, snapshot) {
    const prevLoc = prevProps.location.location.pathname
    const newLoc = this.props.location.location.pathname

    if (prevLoc !== newLoc) {
      const newSlug = this.props.location.match.url === '/' ? 'insights-lead-design-for-brands-of-the-future' : this.props.location.match.url.substr(1)

      this.setState({
        loading: true,
        slug: newSlug
      })

      this.scrollTop()
      this.fetchEndpoint(getApiEndpoint(newSlug), this.init)
    }
  }

  /**
   *
   */
  scrollTop () {
    const scroll = new SmoothScroll()
    const node = document.getElementById('root')

    scroll.animateScroll(node, false, {
      speed: 700,
      topOnEmptyHash: true,
      updateURL: false,
      popstate: false
    })
  }

  /**
   *
   * @param response
   */
  init (response) {
    this.setState({
      loading: false,
      parsedData: parseApiData(response.data, this.state.slug),
      response: 200
    })
  }

  /**
   *
   * @param endpoint
   * @param callback
   */
  fetchEndpoint (endpoint, callback) {
    axios.get(endpoint + '&time=' + new Date().toISOString())
      .then((response) => {
        callback(response)
      })
      .catch((error) => {
        if (error.response) {
          this.setState({
            loading: false,
            data: error.response.data,
            response: error.response.status
          })
          console.error('Couldn\'t fetch from', endpoint, 'due to', error)
        } else {
          console.error('Couldn\'t fetch from', endpoint, 'due to', error, '. Is the API down?')
          this.setState({
            loading: false,
            data: null,
            response: 500
          })
        }
      })
  }

  render () {
    let body
    let menus
    let data = this.state.parsedData

    const slider = !data ? false : (
      <Slider {...data.slider} />
    )

    const pageHeader = (data && this.state.slug !== 'insights-lead-design-for-brands-of-the-future') || (data && this.state.slug === 'insights-lead-design-for-brands-of-the-future' && this.state.loading) ? (
      <PageHeader {...data.header} />
    ) : false

    const grid = !data || !data.grid ? false : <Grid {...data.grid} />
    const content = !data ? false : <Content data={data.content} />
    const favicon = !data ? false : data.favicon

    const loader = this.state.loading ? <Loader /> : ''

    if (this.state.response === 200) {
      menus = data.menus
      body = (
        <div>
          { pageHeader }
          { grid }
          { content }
        </div>
      )
    } else if (this.state.response === 404) {
      menus = this.state.data.menus
      body = (
        <Errors />
      )
    }

    return (
      <main>
        <Favicon url={favicon} />
        <Meta
          meta={data.metaTags}
        />
        <Header
          menu={menus}
          theme={data.headerTheme}
          loader={loader}
        />
        <div className={classnames({
          'page': true,
          'page--loading': this.state.loading
        })}>
          { slider }
          <div className='container-fluid'>
            {body}
          </div>
        </div>
        <Footer
          {...data.footer}
        />
      </main>
    )
  }
}

export default Page



// WEBPACK FOOTER //
// ./src/components/Page/index.js